import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FileText, CheckCircle, AlertCircle, Users, Shield, CreditCard } from 'lucide-react';

const TermsOfService: React.FC = () => {
  return (
    <Container className="py-5">
      {/* <Row className="justify-content-center"> */}
        {/* <Col lg={10}> */}
          {/* <Card className="border-0 shadow-lg"> */}
            <Card.Header className="bg-primary text-white text-center py-4">
              <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
                <FileText size={40} />
                <h2 className="mb-0 fw-bold">Termos de Uso</h2>
              </div>
              <p className="mb-0 opacity-90">
                SystemLoc - Sistema de Gestão para Lojas de Aluguel de Roupas
              </p>
              <small className="opacity-75">Última atualização: {new Date().toLocaleDateString('pt-BR')}</small>
            </Card.Header>
            
            <Card.Body className="p-4">
              {/* Introdução */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">
                  <FileText size={24} className="me-2" />
                  1. Introdução
                </h3>
                <p>
                  Bem-vindo ao <strong>SystemLoc</strong>! Estes Termos de Uso regulam o uso do nosso sistema 
                  de gestão para lojas de aluguel de roupas, incluindo ternos, vestidos e outros itens de festa.
                </p>
                <p>
                  Ao utilizar nossos serviços, você concorda em cumprir estes termos. Se não concordar com 
                  qualquer parte destes termos, não deve utilizar nosso sistema.
                </p>
                <div className="alert alert-info">
                  <AlertCircle size={20} className="me-2" />
                  <strong>Importante:</strong> Estes termos são complementares à nossa Política de Privacidade, 
                  que também deve ser lida e aceita.
                </div>
              </section>

              {/* Definições */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">2. Definições</h3>
                <p>Para fins destes termos, as seguintes definições se aplicam:</p>
                <ul>
                  <li><strong>"SystemLoc"</strong> - O sistema de gestão de aluguel de roupas</li>
                  <li><strong>"Usuário"</strong> - Pessoa física ou jurídica que utiliza o sistema</li>
                  <li><strong>"Cliente"</strong> - Cliente final da loja que aluga produtos</li>
                  <li><strong>"Serviços"</strong> - Funcionalidades oferecidas pelo SystemLoc</li>
                  <li><strong>"Dados"</strong> - Informações inseridas no sistema</li>
                </ul>
              </section>

              {/* Aceitação */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">3. Aceitação dos Termos</h3>
                <p>
                  Ao criar uma conta e utilizar o SystemLoc, você declara que:
                </p>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded bg-light">
                      <CheckCircle size={20} className="text-success me-2" />
                      <strong>Leu e compreendeu</strong> estes termos
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded bg-light">
                      <CheckCircle size={20} className="text-success me-2" />
                      <strong>Concorda</strong> em cumprir todas as condições
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded bg-light">
                      <CheckCircle size={20} className="text-success me-2" />
                      <strong>Possui capacidade legal</strong> para firmar este acordo
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded bg-light">
                      <CheckCircle size={20} className="text-success me-2" />
                      <strong>Forneceu informações</strong> verdadeiras e precisas
                    </div>
                  </div>
                </div>
              </section>

              {/* Serviços */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">4. Descrição dos Serviços</h3>
                <p>
                  O SystemLoc oferece as seguintes funcionalidades para gestão de lojas de aluguel:
                </p>
                
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <div className="text-center p-3 border rounded">
                      <Users size={32} className="text-primary mb-2" />
                      <h6 className="fw-bold">Gestão de Clientes</h6>
                      <p className="small mb-0">Cadastro, edição e controle de clientes</p>
                    </div>
                  </div>
                  
                  <div className="col-md-4 mb-3">
                    <div className="text-center p-3 border rounded">
                      <FileText size={32} className="text-primary mb-2" />
                      <h6 className="fw-bold">Controle de Produtos</h6>
                      <p className="small mb-0">Inventário e catálogo de produtos</p>
                    </div>
                  </div>
                  
                  <div className="col-md-4 mb-3">
                    <div className="text-center p-3 border rounded">
                      <CreditCard size={32} className="text-primary mb-2" />
                      <h6 className="fw-bold">Reservas e Aluguéis</h6>
                      <p className="small mb-0">Sistema completo de reservas</p>
                    </div>
                  </div>
                </div>
                
                <ul className="mt-3">
                  <li><strong>Dashboard</strong> com estatísticas e relatórios</li>
                  <li><strong>Relatórios</strong> de vendas e performance</li>
                  <li><strong>Backup</strong> automático dos dados</li>
                  <li><strong>Suporte técnico</strong> especializado</li>
                </ul>
              </section>

              {/* Responsabilidades */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">5. Responsabilidades do Usuário</h3>
                <p>Como usuário do SystemLoc, você se compromete a:</p>
                
                <h5 className="text-secondary mb-3">5.1 Uso Adequado</h5>
                <ul>
                  <li>Utilizar o sistema apenas para fins comerciais legítimos</li>
                  <li>Não tentar acessar áreas restritas do sistema</li>
                  <li>Não utilizar o sistema para atividades ilegais</li>
                  <li>Respeitar os direitos de terceiros</li>
                </ul>

                <h5 className="text-secondary mb-3">5.2 Segurança da Conta</h5>
                <ul>
                  <li>Manter sua senha segura e confidencial</li>
                  <li>Notificar imediatamente sobre uso não autorizado</li>
                  <li>Fazer logout ao terminar o uso</li>
                  <li>Não compartilhar credenciais de acesso</li>
                </ul>

                <h5 className="text-secondary mb-3">5.3 Dados e Informações</h5>
                <ul>
                  <li>Fornecer informações verdadeiras e atualizadas</li>
                  <li>Responsabilizar-se pelos dados dos clientes cadastrados</li>
                  <li>Manter backups locais de dados importantes</li>
                  <li>Respeitar a privacidade dos clientes</li>
                </ul>
              </section>

              {/* Limitações */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">6. Limitações e Restrições</h3>
                
                <h5 className="text-secondary mb-3">6.1 Uso Proibido</h5>
                <div className="alert alert-danger">
                  <strong>É expressamente proibido:</strong>
                  <ul className="mb-0 mt-2">
                    <li>Modificar, copiar ou distribuir o sistema</li>
                    <li>Realizar engenharia reversa do software</li>
                    <li>Utilizar o sistema para atividades fraudulentas</li>
                    <li>Interferir no funcionamento do sistema</li>
                    <li>Cadastrar informações falsas ou enganosas</li>
                  </ul>
                </div>

                <h5 className="text-secondary mb-3">6.2 Limitações Técnicas</h5>
                <ul>
                  <li>O sistema pode ter períodos de manutenção programada</li>
                  <li>Funcionalidades podem ser alteradas ou removidas</li>
                  <li>Limites de armazenamento podem se aplicar</li>
                  <li>Suporte é fornecido durante horário comercial</li>
                </ul>
              </section>

              {/* Propriedade Intelectual */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">
                  <Shield size={24} className="me-2" />
                  7. Propriedade Intelectual
                </h3>
                <p>
                  O SystemLoc e todo seu conteúdo são protegidos por direitos autorais e outras leis 
                  de propriedade intelectual. Você reconhece que:
                </p>
                <ul>
                  <li><strong>Todos os direitos</strong> sobre o sistema pertencem ao SystemLoc</li>
                  <li><strong>Você não adquire</strong> direitos de propriedade sobre o sistema</li>
                  <li><strong>É proibido</strong> copiar, modificar ou distribuir o sistema</li>
                  <li><strong>Seus dados</strong> permanecem de sua propriedade</li>
                </ul>
              </section>

              {/* Pagamentos */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">8. Pagamentos e Cobrança</h3>
                <p>
                  Se você utiliza uma versão paga do SystemLoc:
                </p>
                <ul>
                  <li><strong>Pagamentos</strong> são processados de forma segura</li>
                  <li><strong>Cobrança</strong> é realizada conforme plano contratado</li>
                  <li><strong>Cancelamento</strong> pode ser feito a qualquer momento</li>
                  <li><strong>Reembolsos</strong> seguem nossa política específica</li>
                </ul>
                <div className="alert alert-warning">
                  <AlertCircle size={20} className="me-2" />
                  <strong>Importante:</strong> Atraso no pagamento pode resultar na suspensão temporária do acesso.
                </div>
              </section>

              {/* Privacidade */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">9. Privacidade e Proteção de Dados</h3>
                <p>
                  O tratamento de dados pessoais é regido por nossa 
                  <strong> Política de Privacidade</strong>, que é parte integrante destes termos.
                </p>
                <p>
                  Você concorda que podemos coletar, usar e armazenar seus dados conforme descrito 
                  na Política de Privacidade, sempre em conformidade com a LGPD.
                </p>
              </section>

              {/* Suspensão */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">10. Suspensão e Encerramento</h3>
                
                <h5 className="text-secondary mb-3">10.1 Suspensão</h5>
                <p>Podemos suspender seu acesso ao sistema em caso de:</p>
                <ul>
                  <li>Violation destes termos de uso</li>
                  <li>Atividade suspeita ou fraudulenta</li>
                  <li>Atraso no pagamento (planos pagos)</li>
                  <li>Solicitação de autoridades competentes</li>
                </ul>

                <h5 className="text-secondary mb-3">10.2 Encerramento</h5>
                <p>
                  Você pode encerrar sua conta a qualquer momento. Nós também podemos encerrar 
                  contas inativas por mais de 12 meses.
                </p>
              </section>

              {/* Limitação de Responsabilidade */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">11. Limitação de Responsabilidade</h3>
                <p>
                  O SystemLoc é fornecido "como está". Não garantimos que o sistema será:
                </p>
                <ul>
                  <li>Livre de erros ou interrupções</li>
                  <li>Compatível com todos os dispositivos</li>
                  <li>Disponível 24/7 sem interrupções</li>
                  <li>Capaz de atender todas as necessidades específicas</li>
                </ul>
                
                <div className="alert alert-info">
                  <strong>Nossa responsabilidade</strong> é limitada ao valor pago pelos serviços 
                  nos últimos 12 meses.
                </div>
              </section>

              {/* Modificações */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">12. Modificações dos Termos</h3>
                <p>
                  Reservamo-nos o direito de modificar estes termos a qualquer momento. 
                  Alterações significativas serão comunicadas com antecedência.
                </p>
                <p>
                  O uso continuado do sistema após modificações constitui aceitação dos novos termos.
                </p>
              </section>

              {/* Lei Aplicável */}
              <section className="mb-5">
                <h3 className="text-primary mb-3">13. Lei Aplicável</h3>
                <p>
                  Estes termos são regidos pelas leis brasileiras. Qualquer disputa será resolvida 
                  nos tribunais competentes do Brasil.
                </p>
              </section>

              {/* Contato */}
              <section className="mb-4">
                <h3 className="text-primary mb-3">14. Contato</h3>
                <p>
                  Para questões sobre estes termos, entre em contato conosco:
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="p-3 border rounded bg-light">
                      <h6 className="text-primary fw-bold">E-mail</h6>
                      <p className="mb-0">contato.systemloc@gmail.com</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-3 border rounded bg-light">
                      <h6 className="text-primary fw-bold">Telefone</h6>
                      <p className="mb-0">(62) 99855-1246</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Rodapé */}
              <hr />
              <div className="text-center text-muted">
                <p className="mb-2">
                  <strong>SystemLoc</strong> - Sistema de Gestão para Lojas de Aluguel de Roupas
                </p>
                <p className="mb-0 small">
                  Estes termos estão em conformidade com a legislação brasileira vigente
                </p>
              </div>
            </Card.Body>
          {/* </Card> */}
        {/* </Col> */}
      {/* // </Row> */}
    </Container>
  );
};

export default TermsOfService;
